import {HasNameInterface} from 'modules/spravochnik/dt-front-page-generator/src/Entity/HasNameInterface';
import {Utils} from './Utils';

export interface SearchResultInterface<TEntity extends HasNameInterface = HasNameInterface> {
    entity: TEntity;
    parent: TEntity|null;
}

export interface SearchServiceInterface<TEntity extends HasNameInterface> {
    searchByName(objects: Array<TEntity>, query: string): Array<SearchResultInterface>;
}

export abstract class AbstractSearchService<TEntity extends HasNameInterface> implements SearchServiceInterface<TEntity> {
    protected like(category: HasNameInterface, text: string): boolean {
        return Utils.like(category.name.name, text);
    }

    abstract filter(res: Array<SearchResultInterface>, element: TEntity, query: string): void;


    protected append(res: Array<SearchResultInterface>, element: HasNameInterface, parent: HasNameInterface|null, text: string): void {
        res.push({
            entity: element,
            parent: parent,
        });
    }

    public searchByName(objects: Array<TEntity>, query: string): Array<SearchResultInterface>
    {
        const text = query.toLowerCase();

        const res = [];
        for (const object of objects) {
            this.filter(res, object, text);
        }

        return res;
    }
}
